'use strict';

import locationStatesTemplate from './locationStates.directive.html';

export default angular
  .module('maestro.directives.components.location-states', [])
  .directive('locationStates', function() {
    return {
      restrict: 'E',
      template: locationStatesTemplate,
      scope: {
        location: '=',
        init: '<',
        once: '<', // Call for states only once
        onBack: '&' // Back button click callback
      },
      controller: ($scope, $q, $log, $sce, $filter, utils, LocationsService, ToastsService) => {
        const $t = $filter('translate');
        let statesLoaded = false;

        $scope.fieldTypes = [
          {
            id: 'string',
            name: $t('locations.edit.locationStates.fields.string')
          },
          {
            id: 'number',
            name: $t('locations.edit.locationStates.fields.number')
          },
          {
            id: 'boolean',
            name: $t('locations.edit.locationStates.fields.boolean')
          },
          {
            id: 'json',
            name: $t('locations.edit.locationStates.fields.json')
          }
        ];

        angular.extend($scope, {
          getLocationStateFields: getLocationStateFields,
          addLocationStateField: addLocationStateField,
          editLocationStateField: editLocationStateField,
          deleteLocationStateField: deleteLocationStateField,
          canEditLocationField: canEditLocationField,
          detectType: detectType,
          validateLocationStateField: validateLocationStateField,

          viewLocationStateField: viewLocationStateField,
          canViewLocationField: canViewLocationField,
          isNothingFound: isNothingFound,
          refreshLocationStates: refreshLocationStates,
          parsePythonString: parsePythonString,

          back: back
        });

        $scope.$watch('init', () => {
          if (!$scope.init || !$scope.location) {
            return;
          }
          if ($scope.once && statesLoaded) {
            return;
          }
          init();
        });

        $scope.$watch('fieldTypeId', () => {
          if ($scope.modalMode === 'new') {
            $scope.fieldValue = void 0;
          }
        });

        // Remove Modals
        $scope.$on('$destroy', () => {
          $('#view-location-state-field-modal').remove();
        });

        function init() {
          $scope.loading = true;
          $scope.states = [];
          initLocationStates('location_properties');
        }

        function initLocationStates(name) {
          return LocationsService.getLocationState($scope.location.id, name)
            .then((data) => {
              let promises = [];

              if (!data) {
                return;
              }

              if (data.value) {
                $scope.states.push({
                  name: name,
                  value: data.value || {}
                });

                let additionalPropNames = data.value['additional_properties'];
                if (additionalPropNames && angular.isArray(additionalPropNames)) {
                  promises.push(initLocationStates(additionalPropNames));
                }
              }

              if (data.states && angular.isArray(data.states)) {
                data.states.forEach(state => {
                  $scope.states.push({
                    name: state.name,
                    value: state.value
                  });
                  if (state.value) {
                    let additionalPropNames = state.value['additional_properties'];
                    if (additionalPropNames && angular.isArray(additionalPropNames)) {
                      promises.push(initLocationStates(additionalPropNames));
                    }
                  }
                });
              }
              return $q.all(promises)
                .then(() => {
                  $scope.loading = false;
                  statesLoaded = true;
                }, (err) => {
                  $scope.loading = false;
                  statesLoaded = true;
                  utils.handleApiError(err);
                });
            });
        }

        function getLocationStateFields(locationStateValue) {
          return locationStateValue ? Object.keys(locationStateValue)
            .filter(fieldName => fieldName && fieldName !== 'additional_properties') : void 0;
        }

        function addLocationStateField() {
          showEditLocationStateFieldModal(void 0, void 0, 'new');
        }

        function editLocationStateField(state, locationStateField) {
          if (!state || !state.value || !locationStateField || !canEditLocationField(state, locationStateField)) {
            return;
          }
          showEditLocationStateFieldModal(state, locationStateField, 'edit');
        }

        function showEditLocationStateFieldModal(state, locationStateField, mode) {
          $scope.modalMode = mode;

          if ($scope.modalMode === 'edit') {
            $scope.selectedState = state;
            $scope.selectedStateName = state.name;
            $scope.fieldName = locationStateField;
            $scope.fieldValue = state.value[locationStateField];
            $scope.fieldType = detectType($scope.fieldValue);
            $scope.fieldTypeId = $scope.fieldType.id;
          } else if ($scope.modalMode === 'new') {
            $scope.selectedState = void 0;
            $scope.selectedStateName = void 0;
            $scope.fieldName = void 0;
            $scope.fieldValue = void 0;
            $scope.fieldType = $scope.fieldTypes[0];
            $scope.fieldTypeId = $scope.fieldType.id;
          } else {
            return;
          }
          fieldValueToView();

          $('#edit-location-state-field-modal').modal({
            autofocus: false,
            closable: true,
            detachable: true,
            onApprove: function() {
              $scope.$applyAsync(() => {
                viewToFieldValue();
                if (!validateLocationStateField()) {
                  return;
                }

                $scope.selectedState.value[$scope.fieldName] = $scope.fieldValue;

                $scope.loading = true;
                saveLocationState($scope.selectedState)
                  .then(() => {
                    ToastsService.success($t('locations.edit.locationStates.removeDialog.success'), $t('locations.edit.locationStates.removeDialog.successDesc'));
                    $('#edit-location-state-field-modal').modal('hide');
                  }, (err) => {
                    $('#edit-location-state-field-modal').modal('hide');
                    utils.handleApiError(err);
                  })
                  .then(() => {
                    init();
                  });
              });
            }
          }).modal('show');
        }

        function deleteLocationStateField(state, locationStateField) {
          if (!state || !locationStateField) {
            return;
          }
          $('#remove-location-state-field-dialog').modal({
            closable: true,
            detachable: true,
            onApprove: function() {
              $scope.$applyAsync(() => {
                $scope.loading = true;
                state[locationStateField] = null;
                saveLocationState(state)
                  .then(() => {
                    ToastsService.success(null, $t('locations.edit.locationStates.removeDialog.success'));
                    $('#remove-location-state-field-dialog').modal('hide');
                  }, (err) => {
                    $('#remove-location-state-field-dialog').modal('hide');
                    utils.handleApiError(err);
                  })
                  .then(() => {
                    init();
                  });
              });
            }
          }).modal('show');
        }

        function saveLocationState(state) {
          return LocationsService.setLocationState($scope.location.id, state.name, { value: state.value });
        }

        function validateLocationStateField() {
          // validate location state
          if (!$scope.selectedState) {
            return false;
          }

          // validate field type
          if (!$scope.fieldType) {
            return false;
          }

          // validate field name
          if (!$scope.fieldName) {
            return false;
          }
          try { // check if it is valid js field name
            let obj = {};
            obj[$scope.fieldName] = 123;
          } catch (e) {
            return false;
          }

          // validate field value
          viewToFieldValue();
          if ($scope.fieldType.id === 'string') {
            if (!angular.isString($scope.fieldValue)) {
              return false;
            }
          } else if ($scope.fieldType.id === 'number') {
            if (!angular.isNumber($scope.fieldValue)) {
              return false;
            }
          } else if ($scope.fieldType.id === 'boolean') {
            if (!($scope.fieldValue === true || $scope.fieldValue === false)) {
              return false;
            }
          } else if ($scope.fieldType.id === 'json') {
            if (!angular.isObject($scope.fieldValue)) {
              return false;
            }
          }
          return true;
        }

        function fieldValueToView() {
          if (!$scope.fieldType) {
            return;
          }
          $scope.stringFieldValue = void 0;
          $scope.numberFieldValue = void 0;
          $scope.booleanFieldValue = false;
          $scope.jsonFieldValue = void 0;
          const fieldTypeId = $scope.fieldType.id;
          if (fieldTypeId === 'string') {
            $scope.stringFieldValue = $scope.fieldValue ? $scope.fieldValue.toString() : '';
          } else if (fieldTypeId === 'number') {
            $scope.numberFieldValue = parseFloat($scope.fieldValue);
          } else if (fieldTypeId === 'boolean') {
            $scope.booleanFieldValue = !!$scope.fieldValue;
          } else if (fieldTypeId === 'json') {
            try {
              $scope.jsonFieldValue = JSON.stringify($scope.fieldValue, null, 2);
            } catch (e) {
              $scope.jsonFieldValue = '';
            }
          }
        }

        function viewToFieldValue() {
          if (!$scope.fieldType) {
            $scope.fieldValue = void 0;
            return;
          }

          const fieldTypeId = $scope.fieldType.id;
          if (fieldTypeId === 'string') {
            $scope.fieldValue = $scope.stringFieldValue || '';
          } else if (fieldTypeId === 'number') {
            $scope.fieldValue = parseFloat($scope.numberFieldValue);
          } else if (fieldTypeId === 'boolean') {
            $scope.fieldValue = !!$scope.booleanFieldValue;
          } else if (fieldTypeId === 'json') {
            try {
              $scope.fieldValue = JSON.parse($scope.jsonFieldValue);
            } catch (e) {
              $scope.fieldValue = void 0;
            }
          }
        }

        function detectType(obj) {
          if (obj == null) {
            return $scope.fieldTypes.find(ft => ft.id === 'string');
          } else if (angular.isNumber(obj)) {
            return $scope.fieldTypes.find(ft => ft.id === 'number');
          } else if (angular.isString(obj)) {
            return $scope.fieldTypes.find(ft => ft.id === 'string');
          } else if (obj === true || obj === false) {// is boolean
            return $scope.fieldTypes.find(ft => ft.id === 'boolean');
          } else if (angular.isObject(obj) || angular.isArray(obj)) {
            return $scope.fieldTypes.find(ft => ft.id === 'json');
          } else {
            console.warn(`Location states does not support fields of type ${typeof obj}`);
            return void 0;
          }
        }

        function canEditLocationField(state, locationStateField) {
          if (!state || !state.value || !locationStateField) {
            return false;
          }
          return detectType(state.value[locationStateField]) != null;
        }

        function canViewLocationField(state, locationStateField) {
          if (!state || !state.value || !locationStateField) {
            return false;
          }
          let type = detectType(state.value[locationStateField]);
          if (type.id === 'json') {
            return true;
          } else if (type.id === 'string') {
            return (state.value[locationStateField] || '').length >= 50;
          } else {
            return false;
          }
        }

        function viewLocationStateField(state, locationStateField) {
          if (!state || !state.value || !locationStateField || !canViewLocationField(state, locationStateField)) {
            return;
          }

          // $scope.selectedState = state;
          // $scope.selectedStateName = state.name;
          // $scope.fieldName = locationStateField;
          // $scope.fieldValue = state.value[locationStateField];
          // $scope.fieldType = detectType($scope.fieldValue);
          // $scope.fieldTypeId = $scope.fieldType.id;

          $scope.viewFieldValue = JSON.stringify(state.value[locationStateField], null, 2);
          let html = Prism.highlight($scope.viewFieldValue, Prism.languages.json, 'json');
          $scope.viewFieldJsonHighlightedHtml = $sce.trustAsHtml(html);

          $('#view-location-state-field-modal').modal({
            autofocus: false,
            closable: true,
            detachable: true
          }).modal('show');
        }

        function isNothingFound() {
          if (!$scope.states || !$scope.searchVal) {
            return false;
          }

          return !$scope.states.some(state => {
            if (!state.value) {
              return false;
            }
            return Object.keys(state.value)
              .some(fieldName => fieldName && fieldName.includes($scope.searchVal) && fieldName !== 'additional_properties');
          });
        }

        function refreshLocationStates() {
          init();
        }

        function parsePythonString(name) {
          if (!name) {
            return $t('notifications.info.unknown-prop');
          }
          return utils.parsePythonString(name);
        }

        function back() {
          $scope.onBack();
        }

      }
    };
  })
  .name;
